<div class="" >        
    <div class="row banner-info-margin-bottom">
        <div class="col-xs-12" id="divImportDiscount">

            <div class="banner-info">
                <div class="icon-informacion icon-align-start"></div>
                <div class="text-banner-info">{{'GROUP_GIFT_CARD_NO_DISCOUNT'|translate}}</div>
            </div>
        </div>
    </div>
</div>